package com.loyola.acessoescola.services.quintadb

import com.loyola.acessoescola.data.AcessoEscolaRecordFields
import io.ktor.http.URLBuilder
import io.ktor.http.Url

fun getFileUrl(recordID: String, fileName: String): String {
    val uri =
        Url("${EndPoints.PROXY_IMAGE.endPoint}?url=https://quintadb.com/images/data4/${AcessoEscolaRecordFields.PHOTO.fieldName}/$recordID/$fileName")
    return URLBuilder(
        url = uri
    ).buildString()
}